// The scale was built using https://coolors.co/
// the colors available in Figma was used - and the algorithm in the tool helped fill out the rest.
const computedEccoGray = {
    25: "#F8F8F8",
    50: "#EEEEEE",
    100: "#EEEEEE",
    150: "#D2D2D2",
    200: "#D2D2D2",
    300: "#D2D2D2",
    400: "#D2D2D2",
    500: "#767676",
    600: "#767676",
    700: "#767676",
    800: "#464646",
    900: "#464646",
};

const colors = {
    transparent: "transparent",
    current: "currentColor",
    black: "#000000",
    white: "#FFFFFF",
    gray: computedEccoGray,
    red: {
        50: "#FCF2F4",
        100: "#A42B1E",
        200: "#A42B1E",
        300: "#A42B1E",
        400: "#A42B1E",
        500: "#A42B1E",
        600: "#A42B1E",
        700: "#A42B1E",
        800: "#A42B1E",
        900: "#A42B1E",
    },
    yellow: {
        50: "#F3EEDD",
        100: "#EDC021",
        200: "#EDC021",
        300: "#EDC021",
        400: "#EDC021",
        500: "#EDC021",
        600: "#EDC021",
        700: "#EDC021",
        800: "#EDC021",
        900: "#EDC021",
    },
    green: {
        50: "#BAF9B8",
        100: "#327533",
        200: "#327533",
        300: "#327533",
        400: "#327533",
        500: "#327533",
        600: "#327533",
        700: "#327533",
        800: "#327533",
        900: "#327533",
    },
    blue: {
        50: "#ECF3FD",
        200: "#042CA0",
    },
    eccoClub: {
        turquoise: "#89DBBE",
        purple: "#9B86F0",
        blue: "#5897EB",
        darkBlue: "#3E76C1",
    },
    whiteTransparent: `rgba(255, 255, 255, 0.92)`,
    grayHover: "#E8E8E8",
    grayUnavailableBg: "rgba(238, 238, 238, 0.4)",
    grayUnavailableText: "rgba(118, 118, 118, 0.4)",
    errorOnBlack: "#FF513D",
    missingLinkRed: "#DA4432",
};

export const productImageBackgroundGradient = "radial-gradient(#FFF 0%, #F7F7F7 75%, #F2F2F2 100%)";
export const productImageHoverBackgroundGradient =
    "radial-gradient(90.05% 50.15% at 50.15% 50%, #FAFAFA 0%, #F0F0F0 75%, #EBEBEB 100%)";
export const saleSeasonGradient =
    "linear-gradient(135deg, #89DBBE 0%, #9B86F0 25%, #5897EB 50%, #9B86F0 75%, #89DBBE 100%)";
export const eccoClubBadgeGradient =
    "linear-gradient(135deg, #89DBBE 0%, #9B86F0 10%, #5897EB 50%, #9B86F0 90%, #89DBBE 100%)";

export default colors;
